// 高级版-模板管理-公共逻辑
import flagType from '../../components/advancedVersion/flagType';

const flag = flagType.flag;

let formatComponents = [
  {
    text: '文本',
    flag: flag.MULTITEXT,
    icon: 'icon-txt1',
  },
  {
    text: '日期',
    flag: flag.DATE,
    icon: 'icon-date',
  },
  {
    text: '手机号',
    flag: flag.PHONE,
    icon: 'icon-phone',
  },
  {
    text: '身份证号',
    flag: flag.IDCARD,
    icon: 'icon-idcard',
  },
  // {
  //   text: '营业执照号',
  //   flag: flag.LICENCENO,
  //   icon: 'icon-yy',
  // },
  {
    text: '统一社会信用代码',
    flag: flag.SOCIALCODE,
    icon: 'icon-ss',
  },
  {
    text: '电子邮箱',
    flag: flag.EMAIL,
    icon: 'icon-email',
  },
  {
    text: '单选',
    flag: flag.RADIO,
    icon: 'icon-radio',
  },
  {
    text: '多选',
    flag: flag.MULTIPLE,
    icon: 'icon-check',
  },
  {
    text: '系统日期',
    flag: flag.SYSTEMDATE,
    icon: 'icon-system-date',
  },
  {
    text: "签署位置（企业）",
    flag: flag.SIGNNATURE,
    icon: "icon-gz"
  },
  {
    text: "签署位置（个人）",
    flag: flag.SIGN,
    icon: "icon-qz"
  },
]

/**
 * 构造新增,存为草稿,提交操作保存模板时的参数
 * @tplId 模板id
 * @tplName 模板名称
 * @orderFlag 是否顺序签字
 * @inputGroups 控件组
 * @signers 签署人信息
 * @files 合同及附件信息
 * @groupIdSet 授权范围
 * */
let formatParam = ({ tplId, tplName, orderFlag, inputGroups, signers, files, groupIdSet }) => {
  // chapteList 处理-处理组件数据，针对格式组件字体数量做处理，放开限制
  let chapteListCopy = inputGroups ? JSON.parse(JSON.stringify(inputGroups[0].inputs)) : [];
  chapteListCopy = chapteListCopy.map(item => {
    // 测数试说新增时是字是10 详情成了100是问题，注释 —— 24/06/25
    // let isChangeItem = formatComponents.find(sub => sub.flag === item.varType); // 格式组件，字体数量不做限制
    // if (isChangeItem) {
    //   item.fontMaxNum = 100; // 这里设置大一点
    // }
    if (item.varType === flag.IDCARD || item.varType === flag.SOCIALCODE) item.fontMaxNum = 18
    if (item.varType === flag.PHONE) item.fontMaxNum = 11;
    const inputItem = {
      'bold': item.bold, //加粗
      'align': item.align, //对齐方式
      'copy': item.copy, // 是否复制
      'inputId': item.inputId,
      'value': item.value, // 填写模板变量时的值
      'varName': item.varName || flagType.getFlagOption(item.varType).title, // 名称
      'varType': item.varType, // 类型
      'defineValue': item.defineValue, // 单选/多选选项list
      'varIsMust': item.varIsMust, // 是否必填
      'w': item.w, // 输入框宽度与合同页面宽度比例
      'h': item.h, // 输入框高度与合同页面宽度比例
      'offsetX': item.offsetX, // 左下角点位置与合同页面左侧比例
      'offsetY': item.offsetY, // 左下角点位置与合同页面顶部比例
      'page': item.page,
      'font': item.font,
      'fontSize': item.fontSize, // 字号--px
      'fontMaxNum': item.fontMaxNum, // 可输入字数
      'signerAbc': item.signerAbc, // 签署方名称
      'formatStyle': item.formatStyle,
      // ...过滤掉前端辅助变量...
      // 'cindex': this.chapterList.length + '-' + new Date().getTime(),
      // 'qsInfo': data.selectSigner.name || '', // 在签章上显示签署方的信息
      // // 基础组件辅助变量
      // 'showSetting': true, // 基础组件-显示组件设置弹窗
    }
    // 如果是批量设置的签章，添加对应字段
    if(item.batch){
      inputItem.batch = item.batch;
      inputItem.copy = true;
    }
    return inputItem;
  });

  // 组件信息
  inputGroups = [{ title: '', inputs: chapteListCopy }];
  // 过滤掉部分前端辅助变量
  let param = {
    tplId: tplId || null,
    tplName: tplName || null,
    orderFlag,
    inputGroups,
    signers: signers && signers.length ? signers.map(item => {
      return {
        "authLevel": item.authLevel, // 验证等极
        "corpUser": item.corpUser || '',
        "emailOrMobile": item.emailOrMobile || '', // 手机或邮箱
        "fix": item.fix, // "是否固定人员1是，0不是"
        "identityNo": +item.userType === 0 ? item.identityNo : item.signatoryIdentityCard, // 证件号
        "name": item.name || '', // 名称
        "orderNum": item.orderNum,
        "signLevel": item.signLevel, // 签章等级
        "signerAbc": item.signerAbc, // 签署人abc标识
        "userType": item.userType, // 用户类型
      }
    }) : [],
    files,
    groupIdSet: groupIdSet && groupIdSet.map(i => {
      if (Object.prototype.toString.call(i) === "[object Object]") {
        return i.corpGroupId
      }
      return i
    })
  }

  // console.log('param:', param)
  return param
}

export {
  formatParam,
  formatComponents
};



// WEBPACK FOOTER //
// ./pages/advancedVersion/advancedVersion.js